import React from 'react';
import './AppLayout.css';

export type WxbAppLayoutDensity = 'comfortable' | 'compact';
export type WxbAppLayoutWidth = 'fluid' | 'contained';

export interface WxbAppLayoutProps extends React.HTMLAttributes<HTMLDivElement> {
  navigation?: React.ReactNode;
  sidebar?: React.ReactNode;
  footer?: React.ReactNode;
  density?: WxbAppLayoutDensity;
  width?: WxbAppLayoutWidth;
}

export interface WxbAppContentProps extends React.HTMLAttributes<HTMLElement> {
  density?: WxbAppLayoutDensity;
  width?: WxbAppLayoutWidth;
}

const joinClasses = (...classes: Array<string | false | undefined>) =>
  classes.filter(Boolean).join(' ');

export const WxbAppLayout: React.FC<WxbAppLayoutProps> = ({
  navigation,
  sidebar,
  footer,
  density = 'comfortable',
  width = 'fluid',
  className = '',
  children,
  ...props
}) => (
  <div
    className={joinClasses(
      'wxb-app-layout',
      `wxb-app-layout-${density}`,
      `wxb-app-layout-${width}`,
      Boolean(sidebar) && 'wxb-app-layout-with-sidebar',
      className,
    )}
    {...props}
  >
    {navigation && <div className="wxb-app-layout-navigation">{navigation}</div>}
    <div className="wxb-app-layout-body">
      {sidebar && <aside className="wxb-app-layout-sidebar">{sidebar}</aside>}
      <main className="wxb-app-layout-main">{children}</main>
    </div>
    {footer && <footer className="wxb-app-layout-footer">{footer}</footer>}
  </div>
);

export const WxbAppContent: React.FC<WxbAppContentProps> = ({
  density = 'comfortable',
  width = 'fluid',
  className = '',
  children,
  ...props
}) => (
  <main
    className={joinClasses(
      'wxb-app-content',
      `wxb-app-content-${density}`,
      `wxb-app-content-${width}`,
      className,
    )}
    {...props}
  >
    {children}
  </main>
);
